import { create } from 'zustand';

const useTenantStore = create((set) => {
  return {
    upsert: (item, schema) => {
      set((state) => {
        return {
          ...state,
          [schema]: {
            ...state[schema],
            [item._id]: { ...state[schema]?.[item._id], ...item },
          },
        };
      });
    },
    remove: (_id, schemaName) => {
      if (!schemaName) {
        throw new Error('Schema name is required to remove an item');
      }
      set((state) => {
        const newState = { ...state };
        delete newState[schemaName][_id];
        return newState;
      });
    },
  };
});

export default useTenantStore;
